import { render } from "./BaseInput.vue?vue&type=template&id=0efbde34"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__